<template>
  <div class="privacidad-container">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1 class="text-h4 mb-4">Política de Privacidad</h1>
          <p class="text-subtitle-1 mb-4">
            <strong>Fecha de vigencia:</strong> 22 de marzo de 2026
          </p>

          <h2 class="text-h6 mt-6 mb-3">1. Responsable del tratamiento</h2>
          <p>
            <strong>Consultora Innova</strong><br />
            RUC: 10459898676<br />
            Domicilio: AV. MESETA DE COLLAO DEL COLLAO MZ.N LOTE.26 A.H.EDILBERTO RAMOS,
            Villa El Salvador, Lima, Perú<br />
            Correo electrónico: informes@consultora-innova.com
          </p>

          <h2 class="text-h6 mt-6 mb-3">2. Información que recopilamos</h2>
          <p>
            Recopilamos información cuando usted visita nuestro sitio web, incluyendo su
            dirección IP, tipo de navegador, páginas visitadas y datos de cookies a través
            de Google AdSense y herramientas de análisis.
          </p>

          <h2 class="text-h6 mt-6 mb-3">3. Uso de cookies y tecnologías similares</h2>
          <p>
            Este sitio utiliza cookies para mejorar la experiencia del usuario, analizar
            el tráfico y mostrar anuncios personalizados. Las cookies son pequeños
            archivos que se almacenan en su dispositivo.
          </p>
          <p>
            Puede gestionar las cookies desde la configuración de su navegador. Sin
            embargo, deshabilitar algunas cookies puede afectar el funcionamiento del
            sitio.
          </p>

          <h2 class="text-h6 mt-6 mb-3">4. Publicidad de Google AdSense</h2>
          <p>
            Este sitio web utiliza Google AdSense, un servicio de publicidad de Google
            LLC. Google utiliza cookies para mostrar anuncios basados en visitas previas a
            este sitio y otros sitios web.
          </p>
          <p>
            Los usuarios pueden desactivar la personalización de anuncios visitando la
            <a
              href="https://www.google.com/settings/ads"
              target="_blank"
              rel="noopener noreferrer"
              >Configuración de anuncios de Google</a
            >. También pueden desactivar las cookies de terceros a través de la
            configuración de su navegador.
          </p>
          <p>
            Para más información sobre cómo Google recopila y procesa datos, consulte la
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              >Política de Privacidad de Google</a
            >.
          </p>

          <h2 class="text-h6 mt-6 mb-3">5. Derechos del usuario</h2>
          <p>Como usuario, usted tiene derecho a:</p>
          <ul>
            <li>Acceder a sus datos personales</li>
            <li>Solicitar la rectificación de datos incorrectos</li>
            <li>Solicitar la eliminación de sus datos</li>
            <li>Oponerse al tratamiento de sus datos</li>
          </ul>
          <p>
            Para ejercer estos derechos, puede escribirnos a
            <strong>informes@consultora-innova.com</strong>
          </p>

          <h2 class="text-h6 mt-6 mb-3">6. Consentimiento</h2>
          <p>
            Al utilizar nuestro sitio web, usted acepta nuestra Política de Privacidad y
            el uso de cookies según lo descrito en este documento.
          </p>

          <v-divider class="my-6"></v-divider>
          <p class="text-center text-caption">
            © 2026 Consultora Innova - Todos los derechos reservados
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PaginaPrivacidad",
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.privacidad-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
}
a {
  color: #1976d2;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
</style>
